import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from 'material-react-table';

// import Swal from 'sweetalert2';
import { MenuItem } from '@mui/material';
import Swal from 'sweetalert2';
const ViewProductionFeedGropyBy = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [permission, setPermission] = useState({});

  useEffect(() => {
    setPermission(FindModuleById(454));
    console.log(permission);

    axios
      .get(`/production-feeds/listing-groupby-all/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setHeaders(response.data.data.header);
          setValue(response.data.data.productions);
          setData(response.data.data.productions_raw);
          setDataa(response.data.data.productions_production);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const columns =
    [
      {
        header: 'Location',
        accessorFn: (row) => `${(row.location_name) ? row.location_name.title : ""} `,
      },
      {
        header: 'Product',
        accessorFn: (row) => `${(row.product_detail) ? row.product_detail.name : ""} `,
      },

      {
        accessorKey: 'product_type',
        header: 'Product Type',
      },
      {
        header: 'Net Weight',

        accessorFn: (row) => {
          if (row.feed_type === 'raw') {
            return row.palletesation_raw_material?.net_weight || '';
          }

          return row.quantity_processed;
        },
      },
      {
        header: 'Palletisation',
        accessorFn: (row) => {
          if (row.feed_type === 'raw') {
            return row.barcode || '';
          }
          if (row.feed_type === 'semifinish') {
            return row.barcode_number || '';
          }
          return '';
        },
      },
      {
        header: 'Raw Material Lot Number',
        accessorFn: (row) => {
          if (row.feed_type === 'raw') {
            return row.lot_number || '';
          }
          return '';
        },
      },
      {
        accessorKey: 'shift_date',
        header: 'Shift Date',
      },
      {
        accessorKey: 'shift',
        header: 'Shift',
      },

      {
        header: 'Created By',
        accessorFn: (row) =>
          row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}`.trim() : '',
      },
       {
        header: 'Created At',
        accessorFn: (row) =>
          row.created_at
            ? row.created_at.replace('T', ' ').substring(0, 19)
            : '',
      }

    ];


  const columns2 =
    [
      {
        header: 'Location',
        accessorFn: (row) => `${(row.location_name) ? row.location_name.title : ""} `,
      },
      {
        header: 'Product',
        accessorFn: (row) => `${(row.product_detail) ? row.product_detail.name : ""} `,
      },

      {
        accessorKey: 'product_type',
        header: 'Product Type',
      },
      {
        header: 'Net Weight',
        //Cell: (props) => <PalletisationCell {...props} />, 
        // Add accessorFn to make searchable
        accessorFn: (row) => {

          if (row.feed_type === 'semifinish') {
            return row.palletesation_production?.total_net_weight || '';
          }
          return row.quantity_processed;
        },
      },
      {
        header: 'Barcode Number',
        accessorFn: (row) => {

          if (row.feed_type === 'semifinish') {
            return row.barcode_number || '';
          }
          return '';
        },
      },

      {
        accessorKey: 'shift_date',
        header: 'Shift Date',
      },
      {
        accessorKey: 'shift',
        header: 'Shift',
      },

      {
        header: 'Created By',
        accessorFn: (row) =>
          row.createdby ? `${row.createdby.first_name} ${row.createdby.last_name}`.trim() : '',
      },
      {
        header: 'Created At',
        accessorFn: (row) =>
          row.created_at
            ? row.created_at.replace('T', ' ').substring(0, 19)
            : '',
      }

    ];


  // const editItem = (item)=>{
  //   window.location.href = "/production-feeds-edit/"+item;
  // }

  const deleteItem = (item) => {
    Swal.fire({
      title: 'Do you really want to delete this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/production-feeds/delete/${item}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
          .then((response) => {
            console.log(response);
            if (response.data.code === 200) {
              Swal.fire(
                'Deleted!',
                'Your Record has been deleted.',
                'success'
              );
              axios
                .get(`/production-feeds/listing-groupby-all/${id}`, {
                  headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
                })
                .then((response) => {
                  if (response.data.code === 200) {
                    setValue(response.data.data.productions);
                    setData(response.data.data.productions_all);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }


  console.log(headers);
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Productions Feed Group By Date and Location</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-feeds">Productions Feed</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Productions Feed Group By Date and Location
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Productions Feed Group By Date and Location</h4>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3" >Shift Date</th>
                        <td className="p-3">{value.shift_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Shift</th>
                        <td className="p-3">{value.shift}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.location ? value.location_name : ""}
                        </td>
                      </tr>

                      <tr>
                        <td className="p-3">
                          <table className="table">
                            <tr>
                              <th className="p-3 text-center" colSpan={2}><h5>Raw Material Fed</h5><hr /></th>
                            </tr>

                            {Object.entries(headers?.raw_count || {}).map(([key, value], index) => (
                              <tr key={`raw-${index}`}>
                                <th className="p-3">{key}</th>
                                <td className="p-3">{Number(value).toFixed(2)} (KG)</td>
                              </tr>
                            ))}

                          </table>
                        </td>

                        <td className="p-3">
                          <table className="table">
                            <tr>
                              <th className="p-3 text-center" colSpan={2}><h5>Semi Finished Fed</h5><hr /></th>
                            </tr>

                            {Object.entries(headers?.production_count || {}).map(([key, value], index) => (
                              <tr key={`raw-${index}`}>
                                <th className="p-3">{key}</th>
                                <td className="p-3">{Number(value).toFixed(2)} (KG)</td>
                              </tr>
                            ))}

                          </table>
                        </td>


                      </tr>

                    </table>

                  </div>
                </div>
              </div>
            </div>


            <div className="row">
              <div className="col-md-12">
                <div className="card p-5">
                  <h4 className="card-title">Listing Productions Feed</h4>
                  <div className="card-body p-0 pt-3">

                    <ul className="nav nav-tabs nav-tabs-bottom">
                      <li className="nav-item">
                        <a className="nav-link active" href="#listing-groupby" data-bs-toggle="tab">Raw Materials </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#listing-all" data-bs-toggle="tab"> Semi Finished</a>
                      </li>
                    </ul>
                    <div className="tab-content">
                      <div className="tab-pane show active" id="listing-groupby">
                        <div className="row" id="listing-followup-groupby">
                          <div className="col-sm-12">
                            <div className="card card-table">
                              <div className="card-body">
                                <div className="table-responsive">
                                  <MaterialReactTable columns={columns} data={data}
                                    enableColumnOrdering
                                    enablePinning
                                    enableRowActions
                                    //renderColumnActionsMenuItems 
                                    renderRowActionMenuItems={({ row }) => [
                                      // <MenuItem key="edit" onClick={() => editItem(row.original.id)}>Edit</MenuItem>,
                                      <MenuItem key="delete" onClick={() => deleteItem(row.original.feed_id)}> Delete </MenuItem>

                                    ]}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane" id="listing-all">
                        <div className="row" id="listing-followup">
                          <div className="col-sm-12">
                            <div className="card card-table">
                              <div className="card-body">
                                <div className="table-responsive">
                                  <MaterialReactTable columns={columns2} data={dataa}
                                    enableColumnOrdering
                                    enablePinning
                                    enableRowActions
                                    //renderColumnActionsMenuItems 
                                    renderRowActionMenuItems={({ row }) => [
                                      // <MenuItem key="edit" onClick={() => editItem(row.original.id)}>Edit</MenuItem>,
                                      <MenuItem key="delete" onClick={() => deleteItem(row.original.feed_id)}> Delete </MenuItem>

                                    ]}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};
export default ViewProductionFeedGropyBy;
